"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Fan = function Fan(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "12.53 22.06 16.2 18.39 12.53 14.77 12.53 22.06",
    style: {
      fill: '#024965'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.48,13.74l-1-1.1L.2,23.11A.52.52,0,0,0,.57,24h9.81a.52.52,0,0,0,.37-.15l.74-.74Z",
    style: {
      fill: '#024965'
    }
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "11.48 1.93 7.85 5.56 11.48 9.15 11.48 1.93",
    style: {
      fill: '#024965'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.93.32A.52.52,0,0,0,23.45,0H13.64a.52.52,0,0,0-.37.15l-.74.74v9.29l1,1.13L23.82.89A.52.52,0,0,0,23.93.32Z",
    style: {
      fill: '#024965'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.16,12.52H13.77l-1.08.93L23.12,23.77a.52.52,0,0,0,.37.15.54.54,0,0,0,.2,0A.52.52,0,0,0,24,23.4V13.59a.52.52,0,0,0-.15-.37Z",
    style: {
      fill: '#024965'
    }
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "22.11 11.48 18.44 7.8 14.8 11.48 22.11 11.48",
    style: {
      fill: '#024965'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.9,11.48h9.31l1.12-1L.86.15A.53.53,0,0,0,.29,0,.44.44,0,0,0,0,.52v9.81a.37.37,0,0,0,.11.37Z",
    style: {
      fill: '#024965'
    }
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "1.94 12.52 5.58 16.17 9.18 12.52 1.94 12.52",
    style: {
      fill: '#024965'
    }
  }));
};

var _default = Fan;
exports["default"] = _default;